import { GlobalService } from './../services/global.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { DialogService } from "../services/dialog.service";

@Injectable({
  providedIn: 'root'
})
export class DocumentGuard  {

  globalService = GlobalService;

  constructor(private router: Router) {

  }

  /**
   * Verifica che la company con cui è loggato l'utente presenti i dati obbligatori
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.globalService;
    //Se la company è null (teoricamente impossibile) o non possiede il regime fiscale, non entra nella sezione
     if (GlobalService.getCurrentCompany() == null || GlobalService.getCurrentCompany().HasTaxRegime != true) {
         DialogService.Confirm("Vous devez d'abord définir le régime fiscal dans les données de l'entreprise. Voulez-vous le définir maintenant ?", () => {
         this.router.navigateByUrl('/core/company');
         return true;
       },true,"Configuration incomplète");
       return false;

     }
    return true;
  }

}
